// frontend/src/routes/HomeRoute.jsx
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import HomePage from "../pages/HomePage";

// Root route ("/"): logged-out visitors see the public homepage,
// logged-in visitors see the app (children, i.e. Dashboard) — same
// onboarding/loading behavior as ProtectedRoute, just without the
// redirect-to-/login step for anonymous visitors.
const HomeRoute = ({ children }) => {
  const { token, loading, user } = useContext(AuthContext);

  if (loading) {
    return <p>Checking authentication...</p>;
  }

  if (!token) {
    return <HomePage />;
  }

  if (token && !user) {
    return <p>Verifying credentials...</p>;
  }

  if (user && !user.onboarding_completed) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default HomeRoute;
